module.exports = __webpack_public_path__ + "static/logistics-tracking-notification@2x-9adfae7d6861e98f2c6885cb34a6c19c.png";